import styled from '@emotion/styled'

export const StyleDownloadAppBannerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: auto;
  width: 100%;
  background-color: #f1fafb;
  padding: 20px 10px;
  overflow-x: hidden;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`

export const StyleImageWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`
export const StyleImage = styled.img`
  width: auto;
  height: auto;
  @media (max-width: 768px) {
    width: 70%;
  }
`
export const StyleRightContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: center;
  @media (max-width: 768px) {
    align-items: center;
  }
`
